import { Button, ButtonTheme } from "@q4/nimbus-ui";
import React from "react";
import { DownloadCapitalFlowButtonClassName, DownloadCapitalFlowButtonProps } from "./DownloadCapitalFlowButton.definition";
import "./DownloadCapitalFlowButton.scss";

const DownloadCapitalFlowButton = (props: DownloadCapitalFlowButtonProps): JSX.Element => {
  const { disabled, onClick, loading } = props;
  return (
    <Button
      className={DownloadCapitalFlowButtonClassName.Base}
      theme={ButtonTheme.Rain}
      label={"Download Capital Flow CSV"}
      disabled={disabled}
      loading={loading}
      onClick={() => {
        (document.activeElement as HTMLElement).blur();
        onClick();
      }}
    />
  );
};

export default DownloadCapitalFlowButton;
